import { Blueprint as ApiBlueprint } from '@leverege/api-attributes';
import RsrcDataSource from "./RsrcDataSource.js";
export default class RsrcBlueprint extends ApiBlueprint {
  getDataSource() {
    if (!this.dataSource) {
      this.dataSource = new RsrcDataSource(this);
    }
    return this.dataSource;
  }
}